import { cn } from "lib/utils"
import { useEffect, useRef } from "react"

interface useStuckProps {
  stuckElement?: Element
  scrollContainer: Element
  enabled?: boolean
  inverse?: boolean
}

function useStuck(props: useStuckProps) {
  const dummyRef = useRef<HTMLDivElement>(null)
  const previousTop = useRef<number | null>(null)
  const stuckElement = useRef<Element | null>(null)

  const dummy = <div ref={dummyRef} className={cn("sticky top-[-2px] left-0 w-[1px] h-[0px]", props.inverse && "!top-auto !bottom-[-2px]")} />

  useEffect(() => {
    if (!props.enabled || !dummyRef.current) return

    if (props.stuckElement) {
      stuckElement.current = props.stuckElement
    } else {
      stuckElement.current = document.getElementById("stuckable")
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Apenas verifica alterações no eixo vertical (top)
        const currentTop = entry.boundingClientRect.top
        const isStuck = entry.intersectionRatio < 1

        if (previousTop.current !== currentTop) {
          // const els = document.querySelectorAll("thead")
          // els?.[0]?.classList.toggle("stuck", isStuck)
          stuckElement.current?.classList.toggle("stuck", isStuck)
          previousTop.current = currentTop
        }
      },
      { threshold: [1], root: props.scrollContainer },
    )
    let dummy = dummyRef.current
    observer.observe(dummy!)

    return () => {
      if (props.enabled) {
        try {
          observer.unobserve(dummy)
        } catch (e) {
          console.log(e)
        }
        observer.disconnect()
      }
    }
  }, [props.stuckElement, props.enabled, props.scrollContainer])

  return { dummy }
}

export default useStuck
